export const rotateArray = (array, rotation) => {
    const n = array.length;
    const rotatedArray = Array(n);
    
    //	Check for sanity
    rotation = (rotation % n + n) % n;
    
    for (let i = 0; i < n; i++) {
        const element = array[i];
        const newIndex = (i + rotation) % n;
        rotatedArray[newIndex] = element;
    }
    return rotatedArray;
}

export const dx2x = array => {
    return array.reduce((result, value, index) => {
        result.push(result[index]+value);
        return result;
    }, [0])
}